import type { ClientAppSettings } from "@ca.vmedia.tv/domains";

/**
 * Represents parameters for LoginSuccess
 */
export class LoginSuccessMutationParams {
    public readonly sessionId: string | null;
    public readonly UserSystemID: string | null = null;

    public constructor(public readonly user: ClientAppSettings) {
        this.sessionId = user.clientCredentials?.sessionId ?? null;
        this.UserSystemID = user.clientCredentials?.UserSystemID ?? null;
    }
}
